import { sub } from 'date-fns';
//
import {
  age,
  boolean,
  company,
  country,
  description,
  email,
  firstName,
  fullAddress,
  fullName,
  lastName,
  percent,
  phoneNumber,
  price,
  rating,
  role,
  sentence,
  title,
} from './assets';

// ----------------------------------------------------------------------

const _mock = {
  id: (index: number) => `e99f09a7-dd88-49d5-b1c8-1daf80c2d7b${index + 1}`,
  email: (index: number) => email[index],
  phoneNumber: (index: number) => phoneNumber[index],
  time: (index: number) => sub(new Date(), { days: index, hours: index }),
  boolean: (index: number) => boolean[index],
  role: (index: number) => role[index],
  company: (index: number) => company[index],
  address: {
    fullAddress: (index: number) => fullAddress[index],
    country: (index: number) => country[index],
  },
  name: {
    firstName: (index: number) => firstName[index],
    lastName: (index: number) => lastName[index],
    fullName: (index: number) => fullName[index],
  },
  text: {
    title: (index: number) => title[index],
    sentence: (index: number) => sentence[index],
    description: (index: number) => description[index],
  },
  number: {
    percent: (index: number) => percent[index],
    rating: (index: number) => rating[index],
    age: (index: number) => age[index],
    price: (index: number) => price[index],
  },
  image: {
    cover: (index: number) => `images/destaque/foto (${index + 1}).webp`,
    product: (index: number) => `images/destaque/foto (${index + 1}).webp`,
    avatar: (index: number) => `images/destaque/foto (${index + 1}).webp`,
  },
};

export default _mock;
